export default "__VITE_ASSET__UgHPV_T4__"